/* Native details retain keyboard and no-JS support. */
if (!customElements.get('studio-header')) {
  customElements.define('studio-header', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.addEventListener('toggle', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLDetailsElement) || !target.open) return;
        const siblings = target.parentElement.querySelectorAll(':scope > details');
        siblings.forEach(item => { if (item !== target) item.open = false; });
      }, { ...options, capture: true });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const open = [...this.querySelectorAll('details[open]')].reverse();
        if (open.length) { open[0].open = false; open[0].querySelector('summary').focus(); }
      }, options);
      this.addEventListener('click', event => {
        if (event.target.closest('a')) this.closeMenus();
      }, options);
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.closeMenus();
      }, options);
      document.addEventListener('focusin', event => {
        if (!this.contains(event.target)) this.closeMenus();
      }, options);
      this.breakpoint = matchMedia('(max-width: 800px)');
      this.breakpoint.addEventListener('change', () => this.closeMenus(), options);
    }
    closeMenus() { this.querySelectorAll('details[open]').forEach(item => { item.open = false; }); }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
